import { render, staticRenderFns } from "./ProfileModal.vue?vue&type=template&id=63352238&scoped=true&"
import script from "./ProfileModal.vue?vue&type=script&lang=ts&"
export * from "./ProfileModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileModal.vue?vue&type=style&index=0&id=63352238&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63352238",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VIcon})
